import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';
// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewCostCenter, updateCostCenter } from '../../../../slices/costCenter/thunk';
import { setRequireCloseModal } from '../../../../slices/costCenter/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { getCompanyList } from '../../../../helpers/establishment/backend_helper';
import OSelect from '../../../../Components/OElements/OSelect';
import OInput from '../../../../Components/OElements/OInput';

const CostCenterForm = ({ dataCostCenter, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();

	const [selectedVisibility, setselectedVisibility] = useState(null);

	const [selectedCompany, setSelectedCompany] = useState(null);
	const handleCompanySelect = (optionSelected) => {
		setSelectedCompany(optionSelected);
		validation.setFieldValue('company_id', optionSelected?._id ?? '');
	};

	const selectorCostCenter = createSelector(
		state => state.CostCenter,
		costCenter => ({
			isAdding: costCenter.isAdding,
			isAdded: costCenter.isAdded,
			isUpdating: costCenter.isUpdating,
			isUpdated: costCenter.isUpdated,
			isLoadingList: costCenter.isLoadingList,
			requireCloseModal: costCenter.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorCostCenter);

	// validation
	const validation = useFormik({
		enableReinitialize: true, // Permite reestablecer valores iniciales si cambian
		initialValues: {
			name: dataCostCenter?.name ?? '',
			code: dataCostCenter?.code ?? '',
			company_id: dataCostCenter?.company_id ?? '',
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			code: Yup.string().required('Campo requerido'),
			company_id: Yup.string().required('Campo requerido'),
		}),
		onSubmit: values => {
			// Construye el objeto base de la compañía
			const costCenter = {
				...values,
			};

			if (isEdit) {
				// Actualiza la compañía existente
				dispatch(updateCostCenter({ ...costCenter, _id: dataCostCenter._id }));
			} else {
				// Crea una nueva compañía
				dispatch(addNewCostCenter(costCenter));
			}
		},
	});


	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={5}>
								<OInput
									name='name'
									label='Nombre del Centro de Costo'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={3}>
								<OInput
									name='code'
									label='Código'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={4}>
								<OSelect
									key={`company_id` || ''}
									label='Empresa'
									id='company_id'
									name='company_id'
									isRequired={true}
									value={dataCostCenter?.company_id || ''}
									onSelect={handleCompanySelect}
									requestApi={() => getCompanyList()}
									validation={validation}
								/>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Centro de Costo
					</button>
				</div>
			</div>
		</Form>
	);
};

export default CostCenterForm;
